let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("65zpK")).then(() => parcelRequire('ltcar'));